import { useState, useEffect, useRef, useCallback } from 'react';
import { TimelineEvent } from '../Components/Timeline/Timeline';

export const useAmbassadorVisibility = (
  activeEvent: TimelineEvent,
  events: TimelineEvent[],
  showDescription: boolean
) => {
  const [isHidden, setIsHidden] = useState(true);
  const wasManuallyShown = useRef(false);
  const previousEvent = useRef<TimelineEvent | null>(null);
  const isFirstClose = useRef(true);
  const [eventChangeCount, setEventChangeCount] = useState(0);

  useEffect(() => {
    if (!showDescription && isFirstClose.current) {
      setIsHidden(false);
      isFirstClose.current = false;
    }
  }, [showDescription]);

  useEffect(() => {
    if (!events.length) return;

    if (
      previousEvent.current &&
      (previousEvent.current.year !== activeEvent.year ||
        previousEvent.current.title !== activeEvent.title) &&
      !isHidden
    ) {
      setEventChangeCount(prevCount => prevCount + 2);
      if (eventChangeCount > 1) {
        setIsHidden(true);
        wasManuallyShown.current = false;
      }
    }

    previousEvent.current = activeEvent;
  }, [activeEvent, events, isHidden]);

  const toggleVisibility = useCallback(() => {
    setIsHidden(prev => {
      if (!prev) {
        wasManuallyShown.current = true;
      }
      return !prev;
    });
  }, []);

  return {
    isHidden,
    toggleVisibility
  };
}; 